// ArchiveContactConfirmationModal — stateless leaf extracted from
// ContactEditModal.tsx render body (Stage 2). Pure render of props: holds no
// useState/useEffect/useRef of its own. The orchestrator owns the
// `showArchiveConfirm` state + the `contact.id` gate and binds the
// archive/cancel callbacks. DOM/markup byte-identical (positioned within the
// same relatively-positioned modal container via `position: absolute`).
export function ArchiveContactConfirmationModal({
  show,
  displayName,
  onCancel,
  onArchive,
}: {
  show: boolean;
  displayName: string;
  onCancel: () => void;
  onArchive: () => void;
}) {
  if (!show) return null;

  return (
    <div style={{
      position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10003, borderRadius: 16,
    }} onClick={onCancel}>
      <div style={{
        background: 'var(--color-surface)', borderRadius: 16, padding: 24, maxWidth: 320, width: '100%',
        boxShadow: '0 12px 32px rgba(0,0,0,0.2)', textAlign: 'center',
      }} onClick={e => e.stopPropagation()}>
        <p style={{ fontSize: 15, fontWeight: 500, color: 'var(--color-text)', margin: '0 0 6px' }}>Archive contact?</p>
        <p style={{ fontSize: 13, color: '#4a4d51', margin: '0 0 20px', lineHeight: 1.5 }}>
          {displayName} will be moved to the archive. You can restore them later.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <button onClick={onCancel}
            style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #DADCE0', background: 'var(--color-surface)', fontSize: 13, cursor: 'pointer', color: '#4a4d51' }}>
            Cancel
          </button>
          <button onClick={onArchive}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#c4841d', color: '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            Archive
          </button>
        </div>
      </div>
    </div>
  );
}
